import * as ASSOCIATION from '../../actionTypes/Association/AssociationActionType';

const initialAssociationListState = {
  association: [],
};

export default function associationReducer(state = initialAssociationListState, action) {
  switch (action.type) {
    case ASSOCIATION.ASSOCIATION_LIST:
      return { ...state, association: action.association };
    default:
      return state;
  }
}
